/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MiddlewareError,
  StoreProfileMasterData,
} from '../models/index';
import {
    MiddlewareErrorFromJSON,
    MiddlewareErrorToJSON,
    StoreProfileMasterDataFromJSON,
    StoreProfileMasterDataToJSON,
} from '../models/index';

export interface GetStoreProfileMasterdataRequest {
    acceptLanguage?: string;
}

/**
 * 
 */
export class StoreProfileMasterDataResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getStoreProfileMasterdata without sending the request
     */
    async getStoreProfileMasterdataRequestOpts(requestParameters: GetStoreProfileMasterdataRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }


        let urlPath = `/api/v1/ui/store-profile/masterdata`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getStoreProfileMasterdataRaw(requestParameters: GetStoreProfileMasterdataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreProfileMasterData>> {
        const requestOptions = await this.getStoreProfileMasterdataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreProfileMasterDataFromJSON(jsonValue));
    }

    /**
     */
    async getStoreProfileMasterdata(requestParameters: GetStoreProfileMasterdataRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreProfileMasterData> {
        const response = await this.getStoreProfileMasterdataRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
